import { createRequest, RequestConfig } from 'app/common/api';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_ticket_order',
};

export const getTicketOrderRequest = (id: number) =>
  createRequest({
    url: config.url,
    method: config.method,
    query: { id: String(id) },
  });
